// Client-side Sentry initialization (Next.js convention; replaces sentry.client.config.ts)
// Runs before React hydration. See: https://nextjs.org/docs/app/api-reference/file-conventions/instrumentation-client

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"f50b29fc09031f2bf3acda3a51398523c1a6c8db"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.26";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs';
import posthog from '@/lib/posthogWrapper';
import { createBeforeSendLog } from '@/utils/sentry/sentryLogFilter';

Sentry.init({
	dsn: 'https://1056b3278ea458672ba876af01e23f36@o4508807514816512.ingest.us.sentry.io/4508808861122560',
	maxValueLength: 2047,
	integrations: [Sentry.browserTracingIntegration()],

	// Revisit later: consider turning off and explicitly tagging only what you need for observability and data safety.
	sendDefaultPii: true,

	// Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
	tracesSampleRate: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 0.025 : 1.0,

	// Setting this option to true will print useful information to the console while you're setting up Sentry.
	debug: process.env.NEXT_PUBLIC_ENVIRONMENT === 'development',
	// Set NEXT_PUBLIC_SENTRY_LOGS_ENABLED=true to send logs (e.g. locally or in preview).
	enableLogs: process.env.NEXT_PUBLIC_SENTRY_LOGS_ENABLED === 'true',

	beforeSendLog: createBeforeSendLog({
		isDebugLogsEnabled: process.env.NEXT_PUBLIC_SENTRY_DEBUG_LOGS === 'true',
	}) as Sentry.NodeOptions['beforeSendLog'],

	beforeSend(event, hint) {
		return new Promise((resolve) => {
			setTimeout(() => {
				try {
					// Set base tags first (these are less likely to throw)
					event.tags = {
						...event.tags,
						domain: window.location.hostname,
						isBuilderPreview: window.location.search.includes('builder.preview='),
						isFeatheryForm: !!document.querySelector('[data-feathery-id]'),
					};

					// Get PostHog distinct_id for error correlation (pseudonymous identifier)
					// Add it after other tags in case it throws
					try {
						const posthogDistinctId = posthog.get_distinct_id();
						if (posthogDistinctId) {
							event.tags.posthog_distinct_id = posthogDistinctId;
						}
					} catch (_error) {
						// If PostHog fails, continue without the distinct_id tag
						// Other tags are already set above
					}

					// Ignore certain builder.io preview errors
					if (
						window.location.search.includes('builder.preview=') &&
						hint?.originalException instanceof Error &&
						hint.originalException.message?.includes('builder')
					) {
						resolve(null); // Ignore event
					} else {
						resolve(event); // Proceed with event
					}
				} catch (_error) {
					// If any error occurs in beforeSend, still send the original event
					// to avoid silently dropping error reports
					resolve(event);
				}
			}, 100); // Small delay (100ms) to allow DOM updates
		});
	},
});
